export default "__VITE_ASSET__6186aa68__"